import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import httpMethod from 'services/update2025/httpMethod';

import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";

import { ForeignerContext } from "components/foreigner/ForeignerContext";
import { findCountryById } from "services/CountryService";
import { Button } from "primereact/button";
import { findNationById } from 'services/NationService';

export const ForeignerEditor = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["foreigner", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const foreignerContext = useContext(ForeignerContext);
    const { foreigner, setForeigner, foreignerDialog, setForeignerDialog } = foreignerContext;

    const [nationality, setNationality] = useState(null);

    useEffect(() => {
        if (foreigner) {
            let nationalityPromise = findNationById(headers, foreigner?.nationality);

            Promise.all([nationalityPromise]).then((values) => {
                const nationalName = values[0]?.data?.name;
                setNationality(`${nationalName}`);
            });
        }
    }, [foreigner]);

    const genders = [
        { label: t("male", { ns: "common" }), value: "1" },
        { label: t("female", { ns: "common" }), value: "0" },
    ];

    const states = [
        { label: t("unverified"), value: "UNVERIFIED" },
        { label: t("verified"), value: "VERIFIED" },
        { label: t("failed"), value: "FAILED" },
    ];

    const hideDialog = () => {
        setForeignerDialog(false);
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog visible={foreignerDialog} style={{ width: "70%" }} header={t("foreigner.titleDetail")} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* số định danh */}
                                <div className="field col-12 md:col-2">
                                    <label htmlFor="id">{t("foreigner.id")}</label>
                                    <InputText id="id" value={foreigner?.id} readOnly />
                                </div>
                                {/* số hộ chiếu */}
                                <div className="field col-12 md:col-2">
                                    <label htmlFor="passportNo">{t("passportNo")}</label>
                                    <InputText id="passportNo" value={foreigner?.passportNo} readOnly />
                                </div>
                                {/* họ và tên */}
                                <div className="field col-12 md:col-4">
                                    <label htmlFor="fullName">{t("fullName")}</label>
                                    <InputText id="fullName" value={foreigner?.fullName} readOnly />
                                </div>
                                {/* ngày sinh */}
                                <div className="field col-12 md:col-2">
                                    <label htmlFor="birthdate">{t("birthdate")}</label>
                                    <InputText id="birthdate" value={foreigner?.birthdate} readOnly />
                                </div>

                                {/* giới tính */}
                                <div className="field col-12 md:col-2">
                                    <label htmlFor="gender">{t("gender")}</label>
                                    <InputText id="gender" value={genders.find((g) => g.value === `${foreigner?.gender}`)?.label} readOnly />
                                </div>
                            </div>
                            <div className="grid">
                                {/* số điện thoại */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="phoneNumber">{t("phoneNumber")}</label>
                                    <InputText id="phoneNumber" value={foreigner?.phoneNumber} readOnly />
                                </div>

                                {/* quốc tịch */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="nationality">{t("nationality")}</label>
                                    <InputText id="nationality" value={nationality} readOnly />
                                </div>

                                {/* email */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="email">{t("email")}</label>
                                    <InputText id="email" value={foreigner?.email} readOnly />
                                </div>

                                {/* trạng thái */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="state">{t("state")}</label>
                                    <InputText id="state" value={states.find((g) => g.value === foreigner?.state)?.label} readOnly />
                                </div>
                            </div>
                            <div className="grid">
                                {/* người tạo */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="createdBy">{t("createdBy", { ns: "common" })}</label>
                                    <InputText id="createdBy" value={foreigner?.createdBy?.username} readOnly />
                                </div>
                                {/* ngày tạo */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="createdDate">{t("createdDate", { ns: "common" })}</label>
                                    <InputText id="createdDate" value={foreigner?.createdDate} readOnly />
                                </div>
                                {/* người sửa */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="modifiedBy">{t("modifiedBy", { ns: "common" })}</label>
                                    <InputText id="modifiedBy" value={foreigner?.modifiedBy?.username} readOnly />
                                </div>
                                {/* ngày sửa */}
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="modifiedDate">{t("modifiedDate", { ns: "common" })}</label>
                                    <InputText id="modifiedDate" value={foreigner?.modifiedDate} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        {/* close */}
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            className="mr-2 p-button-danger"
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
